<template>
    <figure id="icone-cupom">
        <img class="img-responsive" alt="IconeCupom" src="@/assets/images/cupom.png">
    </figure>
</template>

<script>
	export default {
		name: 'IconeCupom',
		data: () => ({
        }),
        props: {
            href:[String]
        },
	}
</script>

<style lang="scss">
	#icone-cupom{
		justify-content: center;
		align-items: center;
		display: flex;
		flex-wrap: wrap;
		margin: auto;
		max-width: 150px;
		margin-bottom: 10px;
		margin-top: 10px;
		img{
			width: 100%;
		}
	}
</style>